import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { Constants } from '../../../endPoints';

export default function Searchcountry({ setCountry }) {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${Constants.listCounty}`);
        setCountries(response.data.data);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };
    fetchCountries();
  }, []);

  // Define the country options for react-select
  const countryOptions = countries.map((country) => ({
    value: country.id,
    label: country.country,
    flagUrl: country.country_symbols, // Assuming 'country_symbols' is the flag URL
  }));

  // Define a function to format the label with the flag and country name
  const formatOptionLabel = ({ label, flagUrl }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img
        src={flagUrl}
        alt={`${label} flag`}
        style={{ width: 20, height: 15, marginRight: 10 }}
      />
      {label}
    </div>
  );

  // Handle selection change and update the parent state
  const handleCountryChange = (selectedOption) => {
    setCountry(selectedOption?.value || ''); // Update parent state with selected country's value
  };

  return (
    <div>
      <Select
        options={countryOptions}
        onChange={handleCountryChange}
        formatOptionLabel={formatOptionLabel}
        placeholder="Search by Country"
        isSearchable
      />
    </div>
  );
}
